/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Disabled_ReasonInputs */

const en_invite_disabled_reason = /** @type {(inputs: Invite_Disabled_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invite has expired, so it cannot be used.`)
};

/** @type {(inputs: Invite_Disabled_ReasonInputs) => LocalizedString} */
const ar_invite_disabled_reason = en_invite_disabled_reason;

/** @type {(inputs: Invite_Disabled_ReasonInputs) => LocalizedString} */
const he_invite_disabled_reason = en_invite_disabled_reason;

/** @type {(inputs: Invite_Disabled_ReasonInputs) => LocalizedString} */
const ur_invite_disabled_reason = en_invite_disabled_reason;

/** @type {(inputs: Invite_Disabled_ReasonInputs) => LocalizedString} */
const es_invite_disabled_reason = en_invite_disabled_reason;

/** @type {(inputs: Invite_Disabled_ReasonInputs) => LocalizedString} */
const fr_invite_disabled_reason = en_invite_disabled_reason;

/** @type {(inputs: Invite_Disabled_ReasonInputs) => LocalizedString} */
const de_invite_disabled_reason = en_invite_disabled_reason;

/** @type {(inputs: Invite_Disabled_ReasonInputs) => LocalizedString} */
const pt_invite_disabled_reason = en_invite_disabled_reason;

/** @type {(inputs: Invite_Disabled_ReasonInputs) => LocalizedString} */
const hi_invite_disabled_reason = en_invite_disabled_reason;

/** @type {(inputs: Invite_Disabled_ReasonInputs) => LocalizedString} */
const bn_invite_disabled_reason = en_invite_disabled_reason;

/**
* | output |
* | --- |
* | "This invite has expired, so it cannot be used." |
*
* @param {Invite_Disabled_ReasonInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_disabled_reason = /** @type {((inputs?: Invite_Disabled_ReasonInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Disabled_ReasonInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_disabled_reason(inputs)
	if (locale === "he") return he_invite_disabled_reason(inputs)
	if (locale === "ur") return ur_invite_disabled_reason(inputs)
	if (locale === "es") return es_invite_disabled_reason(inputs)
	if (locale === "fr") return fr_invite_disabled_reason(inputs)
	if (locale === "de") return de_invite_disabled_reason(inputs)
	if (locale === "pt") return pt_invite_disabled_reason(inputs)
	if (locale === "hi") return hi_invite_disabled_reason(inputs)
	if (locale === "bn") return bn_invite_disabled_reason(inputs)
	return /** @type {LocalizedString} */ ("This invite has expired, so it cannot be used.")
});